<form #mapForm="ngForm" autocomplete="off" class="main-container">
  <div class="form-row">
    <mat-form-field class="fullWidth">
      <mat-label>VoIP Peer Name</mat-label>
      <input matInput required [(ngModel)]="data.name" name="name" maxlength="255">
    </mat-form-field>
  </div>
</form>
